<template>
  <div class="header-contain">
    <div class="header-top pcLayout text_between">
      <Logo class="header-logo" :follow_name="'logo'" :name="'common'"/>
      <div class="header-login pointer">
        <el-avatar size="small" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"/>
        <span class="login-font" v-if="!userName">用户登录</span>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link login-font">
             您好，{{ userName }}
            <i class="el-icon-arrow-down el-icon--right"/>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-place" command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="nav-contain pcLayout text_between">
      <div class="nav-a">
        <router-link to="/workflow/index" tag="a" active-class="active">首页</router-link>
        <router-link to="/workflow/servicecenter?keyword=all&type=tag" tag="a" active-class="active">服务中心</router-link>
        <router-link to="/workflow/todo" tag="a"
                     :class="routeName() == 'todo'||routeName() == 'doing'||routeName() == 'done'||routeName() == 'flow_cc'||routeName() == 'favorite'?'active':''">
          个人中心
          <el-badge v-if="todoLength>0" :value="todoLength"></el-badge>
        </router-link>
        <router-link to="/workflow/inventory" tag="a" active-class="active">部门职责</router-link>

<!--        <a href="http://baidu.com" target="_blank">效能监督</a>-->
        <router-link to="/workflow/help" tag="a" active-class="active">帮助中心</router-link>
      </div>
      <el-input class="pointer" v-if="routeName() == 'apps'" v-model="indexSearchKeyword" suffix-icon="el-icon-search"
                placeholder="请输入流程名称,服务类别,服务部门" @change="indexToSearch"/>
    </div>
    <template v-if="routeName() == 'todo'||routeName() == 'doing'||routeName() == 'done'||routeName() == 'flow_cc'||routeName() == 'favorite'">
      <img class="todo-image" src="@/assets/images/grzx.jpg" alt=""/>
      <h3 class="todo-description">个人中心</h3>
    </template>
  </div>
</template>
<script>
import {mapActions} from 'vuex'

export default {
  name: 'myHeader',
  inject: ['routeName'],
  data() {
    return {
      indexSearchKeyword: ''
    }
  },
  computed: {
    userName() {
      return this.$store.getters.getUserInfo.name;
    },
    todoLength() {
      return this.$store.getters.getDataLength['todo'];
    }
  },
  methods: {
    ...mapActions("oidcStore", ['signOutOidc']),
    indexToSearch() {
      if (this.indexSearchKeyword) {
        this.$emit('searchText', this.indexSearchKeyword);
        this.indexSearchKeyword=''
      }
    },
    pushUri(val) {
      window.open(val, '_black');
    },
    handleCommand(command) {
      if (command == 'logout') {
        this.signOutOidc();
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/todoCenter/default/workflow/layout/myHeader.vue